/* eslint-disable camelcase */
import { createWebHistory, createRouter } from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

const router = createRouter({
    history: createWebHistory(import.meta.env.VITE_BASE_PATH || ''),
    routes: [
        {
            path: '/',
            name: 'programmeconnect',
            component: () => import('@/layout/index.vue'),
            children: [
                {
                    path: '',
                    name: 'Homepage',
                    alias: 'index.html',
                    component: () =>
                        import('@/views/Homepage/index.vue').catch(() => window.location.reload()),
                    meta: { title: 'homepage', screenId: 'S001', isHomepage: true }
                },
                {
                    path: 'contents',
                    name: 'contents',
                    component: () =>
                        import('@/views/Subpage/Content.vue').catch(() => window.location.reload()),
                    beforeEnter: to => {
                        if (!to?.query?.template && !to?.query?.preview) {
                            return { name: 'Error404' }
                        }
                    }
                },
                {
                    path: 'channel',
                    name: 'channel',
                    component: () =>
                        import('@/views/Subpage/Channel.vue').catch(() => window.location.reload())
                },
                {
                    path: 'category',
                    name: 'category',
                    component: () =>
                        import('@/views/Subpage/Category.vue').catch(() => window.location.reload())
                },
                {
                    path: 'ecom',
                    name: 'ecom',
                    component: () =>
                        import('@/views/Subpage/More.vue').catch(() => window.location.reload()),
                    meta: { typeName: 'ecom' }
                },
                {
                    path: 'mytvsuper',
                    name: 'mytvsuper',
                    component: () =>
                        import('@/views/Subpage/More.vue').catch(() => window.location.reload()),
                    meta: { typeName: 'mytvsuper', useMap: true }
                },
                {
                    path: 'tvbweekly',
                    name: 'tvbweekly',
                    component: () =>
                        import('@/views/Subpage/More.vue').catch(() => window.location.reload()),
                    meta: { typeName: 'tvbweekly' }
                },
                {
                    path: 'tvbi',
                    name: 'tvbi',
                    component: () =>
                        import('@/views/Subpage/More.vue').catch(() => window.location.reload()),
                    meta: { typeName: 'tvbi' }
                },
                {
                    path: '404.html',
                    name: 'Error404',
                    component: () =>
                        import('@/views/Error/index.vue').catch(() => window.location.reload()),
                    meta: { title: '404' }
                }
            ]
        },
        {
            path: '/500.html',
            name: 'Error500',
            component: () =>
                import('@/views/Error/index.vue').catch(() => window.location.reload()),
            meta: { title: '500' }
        },
        {
            path: '/404',
            redirect: { name: 'Error404' }
        },
        {
            path: '/500',
            redirect: { name: 'Error500' }
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: { name: 'Error404' }
        }
    ]
})

router.beforeEach(async (_to, _from, next) => {
    window.layerPageTitle = ''
    NProgress.start()

    try {
        if (_to.path[_to.path.length - 1] === '/' && _to.path !== '/') {
            _to.path = _to.path.slice(0, _to.path.length - 1)
            next(_to)
        } else {
            next()
        }
    } catch (error) {
        next()
        // eslint-disable-next-line no-console
        console.error(error)
    }
})

router.afterEach(() => {
    NProgress.done()
})

export default router
